import { render } from "./ViewChallenge.vue?vue&type=template&id=ee989f9e&scoped=true"
import script from "./ViewChallenge.vue?vue&type=script&lang=js"
export * from "./ViewChallenge.vue?vue&type=script&lang=js"

import "@/css/views/view-challenge.css?vue&type=style&index=0&id=ee989f9e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee989f9e"]])

export default __exports__